import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { environment } from '../../../environments/environment';

/**
 * Environments where features that are still in active testing are exposed.
 *
 * This is an allowlist (keyed off `environment.analyticsEnv`) rather than a
 * blocklist so that any new or customer-facing environment hides in-testing
 * features by default — a build only shows them if it explicitly opts in here.
 */
const IN_TESTING_FEATURE_ENVS = [
  'local',
  'dev-local',
  'dev',
  'sandbox-local',
  'sandbox',
];

/**
 * Whether features still in active testing should be exposed in the current
 * environment. Use this for UI gating (e.g. hiding nav items); use
 * {@link inTestingFeatureGuard} to gate the corresponding routes.
 */
export const inTestingFeaturesEnabled =
  IN_TESTING_FEATURE_ENVS.includes(environment.analyticsEnv);

/**
 * Route guard for features that are still in active testing. Allows navigation
 * in environments where such features are enabled, otherwise redirects to the
 * dashboard. Note this is UX gating only — the underlying APIs must still
 * enforce their own authorization.
 */
export const inTestingFeatureGuard: CanActivateFn = () =>
  inTestingFeaturesEnabled ? true : inject(Router).createUrlTree(['/dashboard']);
